import axios from 'axios';
import type { Clause } from '../Responses/Filters/Clause';
import type { QuestionResults } from './AggregatedResult';

type QuestionResultsData = {
  data: {
    results: QuestionResults;
    // eslint-disable-next-line camelcase
    uses_uuid: boolean;
  };
};

export async function getQuestionResults(
  siteId: number | string,
  surveyId: number,
  clauses: Clause[],
): Promise<QuestionResults> {
  const path = `/api/v3/sites/${siteId}/polls/${surveyId}/results`;

  const response = await axios.get<QuestionResultsData>(path, {
    params: { survey_query: { clauses } },
  });

  return response.data.data.results;
}
